import React, { type HTMLAttributes } from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import type { AspectRatio } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';

import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../../config/constants';

interface VariableRatiosPictureProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  image: MediaReferenceField<'image'>;
  aspectRatios: [AspectRatio, AspectRatio, AspectRatio, AspectRatio, AspectRatio]
}

const VariableRatiosPicture: React.FC<VariableRatiosPictureProps> = ({
  image,
  aspectRatios,
}) => (
  // For images above the fold, we want to render a Picture component.
  // When using the DynamicMediaItem with the prop 'aboveTheFold' we would create an object
  // with only 'original' ratios because we don't have windowDimensions. (see useLayoutVariables)
  //
  // When the site is loaded by the browser, React recognizes that it should recalculate the ratio,
  // the resulting HTML differs from the server, so React does not replace the HTML.
  //
  // TODO: https://uncinc.monday.com/boards/99020894/pulses/8667876706
  <Image
    src={{
      [SCREEN_MOBILE]: image.styles?.[`ratio_${aspectRatios[0]}_sm`],
      [SCREEN_TABLET]: image.styles?.[`ratio_${aspectRatios[1]}_md`],
      [SCREEN_NORMAL]: image.styles?.[`ratio_${aspectRatios[2]}_md`],
      [SCREEN_WIDE]: image.styles?.[`ratio_${aspectRatios[3]}_lg`],
      [SCREEN_HUGE]: image.styles?.[`ratio_${aspectRatios[4]}_lg`],
    }}
    lazyload={false}
    alt={image.alt}
  />
);

export default VariableRatiosPicture;
